import { formatDate } from '@luxuryescapes/lib-refunds'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Typography from 'LuxKit/Typography/Typography'
import InlineIcon from 'components/utils/InlineIcon'
import React, { ReactElement } from 'react'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

interface Props {
  icon?: ReactElement | false
  cancellationPolicy: App.BedbankCancellationPolicy;
  showHotelOnly?: boolean;
}

function BedbankPropertyCancellationPoliciesBase({ icon, cancellationPolicy, showHotelOnly = true }: Props) {
  const hasRateCancellationPolicy = !!cancellationPolicy.policies.length

  return <BodyTextBlock startIcon={icon} variant="medium">
    <Typography colour="highlight-secondary" as="b" wrap="no-wrap">Free cancellation</Typography>
    {hasRateCancellationPolicy && <>
      {' '}
      until {formatDate.formattedShortDateByTimezone(cancellationPolicy.policies[0]?.start, cancellationPolicy.policies[0]?.timezone)}
    </>}
    {' '}
    <Typography as="span" wrap="no-wrap">{showHotelOnly && '(hotel only) '}<InlineIcon Icon={LineInfoCircleIcon} /></Typography>
  </BodyTextBlock>
}

export default BedbankPropertyCancellationPoliciesBase
